import React from "react";

const About = () => {
  return (
    <>
      <h1 className="text-center p-5"> I am from About componante</h1>
    </>
  );
};

export default About;
